
import { signInWithEmailAndPassword, signOut, createUserWithEmailAndPassword, browserLocalPersistence, browserSessionPersistence, setPersistence } from "firebase/auth";
import { ref, get, set } from "firebase/database";
import { auth, db } from "../config/firebase";

export const login = async (email, password, dispatch, setUser, rememberMe) => {
  try {
    await setPersistence(auth, rememberMe ? browserLocalPersistence : browserSessionPersistence);

    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const uid = userCredential.user.uid;

    const snapshot = await get(ref(db, `users/${uid}`));
    if (!snapshot.exists()) throw new Error("User record not found");

    const userData = snapshot.val();

    // No need to fetch companyName here anymore
    const enrichedUser = { id: uid, email, ...userData };

    dispatch(setUser(enrichedUser));
    return enrichedUser;
  } catch (error) {
    console.error("[Login Error]", error.message);
    throw error;
  }
};

export const logoutUser = async (dispatch, logout) => {
  await signOut(auth);
  dispatch(logout());
};